export const FormReposition = (siblings, position, condition, increment) => {
  return siblings
    .map(item =>
      Object.entries(item.options.position)
        .map(([key, value]) => {
          if (condition(value, position[key])) {
            return {
              id: item.id,
              key,
              from: item.options.position[key],
              to: item.options.position[key] + increment,
            }
          }
          return null
        })
        .filter(i => !!i)
    )
    .reduce((acc, crr) => [...acc, ...crr], [])
}

export const Reposition = (siblings, options, condition, increment) => {
  return siblings
    .map(item =>
      Object.entries(item.options)
        .map(([key, value]) => {
          if (condition(value.position, options[key].position)) {
            return {
              id: item.id,
              key,
              from: item.options[key].position,
              to: item.options[key].position + increment,
            }
          }
          return null
        })
        .filter(i => !!i)
    )
    .reduce((acc, crr) => [...acc, ...crr], [])
}
